module.exports = __webpack_public_path__ + "static/media/squirrel.mascot-icon-01.95582555.svg";